<script lang="ts">
    import type HTMLSanitizerInterface from "@modules/money/HTMLSanitizer/HTMLSanitizerInterface";
    import { map } from "rxjs/operators";

    import RewardsCurrencyFormatter from "../lib/RewardsCurrencyFormatter";

    export let amount: number;
    export let rewardsCurrencyFormatter: RewardsCurrencyFormatter;
    export let sanitizer: HTMLSanitizerInterface;

    const escapedFormatted$ = rewardsCurrencyFormatter
        .selectFormattedCurrency(amount)
        .pipe(
            map((formattedCurrency) => {
                return sanitizer.sanitize(formattedCurrency);
            })
        );
</script>

{#if $$slots.default}
    <slot amount={$escapedFormatted$} />
{:else}
    {@html $escapedFormatted$}
{/if}
